import { useMemo } from 'react'

import { HiExclamation } from 'react-icons/hi'

import { Box, Spinner } from '@chakra-ui/react'

import { VirusScanStatus } from '@/graphql/generated/schemas'

import { SOPType } from '../types/types'
import { SOPStatusBox } from './SOPStatusBox'

export const SOPDocument = ({
  sop,
  isLoading,
}: {
  sop: SOPType
  isLoading: boolean
}) => {
  const status = sop?.status

  // Extract base URL without S3 signature parameters
  const baseUrl = useMemo(() => {
    if (!sop?.url) return ''
    return sop.url.split('?')[0]
  }, [sop?.url])

  // Only recalculate when base URL changes to prevent iframe reloads on signature refresh
  const pdfUrl = useMemo(
    () => (sop?.url ? `${sop.url}#toolbar=1&navpanes=0&view=FitH` : ''),
    [baseUrl]
  )

  if (isLoading || status === VirusScanStatus.Unscanned) {
    return (
      <SOPStatusBox isLoading={isLoading} title='Uploading'>
        <Spinner
          color='#298bbd'
          data-testid='SOPDocument:spinner'
          emptyColor='gray.300'
          mt='10px'
          size='lg'
          thickness='4px'
        />
      </SOPStatusBox>
    )
  }
  if (status === VirusScanStatus.Infected) {
    return (
      <SOPStatusBox title='Upload failed'>
        <HiExclamation color='#D01030' size='54px' />
      </SOPStatusBox>
    )
  }

  return (
    <Box
      as='iframe'
      border='none'
      data-testid='SOPDocument:iframe'
      display='block'
      h='100%'
      src={pdfUrl}
      title='SOP Document'
      w='100%'
    />
  )
}
